import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosDefaultApi } from "src/lib/axios";
import { MutationConfig, queryClient } from "src/lib/react-query";
import useNotification from "src/store/Notifications/useNotification";


const deleteCostBy = ({ costById }: { costById: number }): Promise<string> => {
  return axiosDefaultApi.delete(`api/CostBy/DeleteCostBy/${costById}`);
};

type QueryFnType = typeof deleteCostBy;

type UseDeleteCostByOptions = {
  costById: number;
  config?: MutationConfig<QueryFnType>;
};

export const useDeleteCostBy = ({ config }: UseDeleteCostByOptions ) => {
  const { addNotification, setIsNotificationVisible } = useNotification();
  return useMutation({
    onError: (error: AxiosError<any>) => {
      if (error.response && error.response.data && error.response.data.message) {
        const responseMessage = error.response?.data.message;
        console.log(responseMessage);
        addNotification(responseMessage.toString(), 500);
        setIsNotificationVisible(true);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getAllCostBy"]);
      addNotification(`Η παράμετρος 'Κόστος ανά' Διαγράφηκε.`, 200);
      setIsNotificationVisible(true);
    },
    ...config,
    mutationFn: deleteCostBy,
  });
};
